import * as types from './mutation-types'

let defaultObject = () => ({ data: {} })

export default {
  [types.SET_TASK] (state, payload) {
    if (payload === null) payload = defaultObject()
    state.task = payload
  },
  [types.SET_TASKS] (state, payload) {
    state.tasks = payload.data
    state.pagination = { total: payload.total, current_page: payload.current_page }
  },
  [types.SET_CONTACTS] (state, payload) {
    state.contacts = payload.data
    state.paginationC = payload.meta.pagination
  }
}
